"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = SttNewSelect;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _deburr = _interopRequireDefault(require("lodash/deburr"));
var _downshift = _interopRequireDefault(require("downshift"));
var _styles = require("@material-ui/core/styles");
var _TextField = _interopRequireDefault(require("@material-ui/core/TextField"));
var _Paper = _interopRequireDefault(require("@material-ui/core/Paper"));
var _styles2 = _interopRequireDefault(require("./styles"));
var _SttMenuItem = _interopRequireDefault(require("../SttNavigation/SttMenuItem"));
var _KeyboardArrowDown = _interopRequireDefault(require("@material-ui/icons/KeyboardArrowDown"));
var _KeyboardArrowUp = _interopRequireDefault(require("@material-ui/icons/KeyboardArrowUp"));
var _HighlightOff = _interopRequireDefault(require("@material-ui/icons/HighlightOff"));
var _excluded = ["stateReducer"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function renderSuggestion(suggestionProps) {
  var suggestion = suggestionProps.suggestion,
    index = suggestionProps.index,
    itemProps = suggestionProps.itemProps,
    highlightedIndex = suggestionProps.highlightedIndex,
    selectedItem = suggestionProps.selectedItem;
  var isHighlighted = highlightedIndex === index;
  var isSelected = (selectedItem || "").indexOf(suggestion.label) > -1;
  return /*#__PURE__*/_react["default"].createElement(_SttMenuItem["default"], _extends({}, itemProps, {
    key: suggestion.label,
    selected: isHighlighted,
    component: "div",
    style: {
      fontWeight: isSelected ? 500 : 400
    }
  }), suggestion.label);
}
renderSuggestion.propTypes = {
  highlightedIndex: _propTypes["default"].oneOfType([_propTypes["default"].oneOf([null]), _propTypes["default"].number]).isRequired,
  index: _propTypes["default"].number.isRequired,
  itemProps: _propTypes["default"].object.isRequired,
  selectedItem: _propTypes["default"].string.isRequired,
  suggestion: _propTypes["default"].shape({
    label: _propTypes["default"].string.isRequired
  }).isRequired
};
function getSuggestions(data, value) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
    _ref$showEmpty = _ref.showEmpty,
    showEmpty = _ref$showEmpty === void 0 ? false : _ref$showEmpty;
  var inputValue = (0, _deburr["default"])(value.trim()).toLowerCase();
  var inputLength = inputValue.length;
  var count = 0;
  return inputLength === 0 && !showEmpty ? [] : data.filter(function (suggestion) {
    var keep = count < 5 && suggestion.label.slice(0, inputLength).toLowerCase() === inputValue;
    if (keep) {
      count += 1;
    }
    return keep;
  });
}
var sttStyles = (0, _styles.makeStyles)(function (theme) {
  return (0, _styles2["default"])(theme);
});
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    container: {
      position: "relative"
    },
    paper: {
      position: "absolute",
      zIndex: 10,
      left: 0,
      right: 0
    }
  };
});
var ControllerButton = (0, _styles.styled)('button')({
  backgroundColor: 'transparent',
  border: 'none',
  position: 'absolute',
  right: 0,
  top: 0,
  cursor: 'pointer',
  width: 47,
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  justifyContent: 'center',
  alignItems: 'center'
});
function SttNewSelect(props) {
  var classes = useStyles();
  var sttClasses = sttStyles();
  var stateReducer = props.stateReducer,
    other = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_downshift["default"], null, function (_ref2) {
    var clearSelection = _ref2.clearSelection,
      getInputProps = _ref2.getInputProps,
      getToggleButtonProps = _ref2.getToggleButtonProps,
      getItemProps = _ref2.getItemProps,
      getLabelProps = _ref2.getLabelProps,
      getMenuProps = _ref2.getMenuProps,
      highlightedIndex = _ref2.highlightedIndex,
      inputValue = _ref2.inputValue,
      isOpen = _ref2.isOpen,
      openMenu = _ref2.openMenu,
      selectedItem = _ref2.selectedItem;
    var _getInputProps = getInputProps(_objectSpread({
        onChange: function onChange(event) {
          if (event.target.value === "") {
            clearSelection();
          }
          if (props.onChange) props.onChange(event);
        },
        onFocus: openMenu
      }, other)),
      inputProps = _extends({}, _getInputProps);
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: classes.container
    }, /*#__PURE__*/_react["default"].createElement(_TextField["default"], {
      margin: "dense",
      variant: "outlined",
      fullWidth: true,
      label: inputProps.label,
      InputLabelProps: getLabelProps({
        shrink: selectedItem || isOpen ? true : false,
        classes: {
          root: sttClasses.label,
          focused: sttClasses.cssfocused
        }
      }),
      InputProps: {
        inputProps: inputProps,
        classes: {
          root: sttClasses.input,
          focused: sttClasses.cssfocused,
          notchedOutline: sttClasses.notchedOutline
        }
      }
    }), selectedItem ? /*#__PURE__*/_react["default"].createElement(ControllerButton, _extends({}, getToggleButtonProps(), {
      onClick: clearSelection
    }), /*#__PURE__*/_react["default"].createElement(_HighlightOff["default"], null)) : /*#__PURE__*/_react["default"].createElement(ControllerButton, getToggleButtonProps(), isOpen ? /*#__PURE__*/_react["default"].createElement(_KeyboardArrowUp["default"], null) : /*#__PURE__*/_react["default"].createElement(_KeyboardArrowDown["default"], null)), /*#__PURE__*/_react["default"].createElement("div", getMenuProps(), isOpen ? /*#__PURE__*/_react["default"].createElement(_Paper["default"], {
      className: classes.paper,
      square: true
    }, getSuggestions(props.data, inputValue, {
      showEmpty: true
    }).map(function (suggestion, index) {
      return renderSuggestion({
        suggestion: suggestion,
        index: index,
        itemProps: getItemProps({
          item: suggestion.label
        }),
        highlightedIndex: highlightedIndex,
        selectedItem: selectedItem
      });
    })) : null));
  });
}